unit View.Aliquotas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewAliquotasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbvalor: TLabel;
    edvalor: TDBEdit;
    lblegenda: TLabel;
    edlegenda: TDBEdit;
    lbaliquota_compra: TLabel;
    edaliquota_compra: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientAliquotasGet: TXDataWebClient;
    XDataClientAliquotasDelete: TXDataWebClient;
    AliquotasDataset: TXDataWebDataSet;
    AliquotasDatasetid: TIntegerField;
    AliquotasDatasetaliado_id: TIntegerField;
    AliquotasDatasetdata_base_id: TIntegerField;
    AliquotasDatasetvalor: TFloatField;
    AliquotasDatasetlegenda: TStringField;
    AliquotasDatasetaliquota_compra: TBooleanField;
    AliquotasDatasetcodigo_interno: TIntegerField;
    AliquotasDatasetexcluido: TBooleanField;
    AliquotasDatasetinclusao: TDateTimeField;
    AliquotasDatasetalteracao: TDateTimeField;
    AliquotasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientAliquotasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientAliquotasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientAliquotasDeleteError(Error: TXDataClientError);
    procedure AliquotasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewAliquotasEdit: TFViewAliquotasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewAliquotasEdit }

procedure TFViewAliquotasEdit.btSaveClick(Sender: TObject);
begin
  if AliquotasDataset.State in dsEditModes then
  begin
        AliquotasDataset.Post;
    AliquotasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewAliquotasEdit.btDeleteClick(Sender: TObject);
begin
  if AliquotasDataset.State in dsEditModes then
    AliquotasDataset.Post;
  XDataClientAliquotasDelete.Delete(AliquotasDataset.EntitySetName,
    TJSObject(AliquotasDataset.CurrentData));
end;


class function TFViewAliquotasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewAliquotasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewAliquotasEdit.InsertEntity;
begin
  AliquotasDataset.Close;
  AliquotasDataset.SetJsonData('{}');
  AliquotasDataset.Open;
  AliquotasDataset.Insert;
end;

class function TFViewAliquotasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAliquotasEdit(AForm).FInserting := AInserting;
    TFViewAliquotasEdit(AForm).FId := AId;
    TFViewAliquotasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewAliquotasEdit(AForm).InsertEntity
    else
      TFViewAliquotasEdit(AForm).LoadEntity;
    TFViewAliquotasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewAliquotasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewAliquotasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    AliquotasDataset.Connection.Model.DefaultSchema.FindEntityType(
      AliquotasDataset.EntitySetName
    )
  );
  XDataClientAliquotasGet.Get(AliquotasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewAliquotasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewAliquotasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewAliquotasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewAliquotasEdit.XDataClientAliquotasGetLoad(Response: TXDataClientResponse);
begin
  AliquotasDataset.Close;
  AliquotasDataset.SetJsonData(Response.Result);
  AliquotasDataset.Open;
  
  AliquotasDataset.Edit;  
end;

procedure TFViewAliquotasEdit.XDataClientAliquotasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewAliquotasEdit.XDataClientAliquotasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewAliquotasEdit.AliquotasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewAliquotasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewAliquotasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.aliquotas.form.message');
  lbMessage := TLabel.Create('view.aliquotas.form.message.label');
  btCloseMessage := TButton.Create('view.aliquotas.form.message.button');
  btCancel := TButton.Create('view.aliquotas.form.btBack');
  btSave := TButton.Create('view.aliquotas.form.btSave');
  btDelete := TButton.Create('view.aliquotas.form.btDelete');
  lbid := TLabel.Create('view.aliquotas.form.lbid');
  edid := TDBEdit.Create('view.aliquotas.form.edid');
  lbaliado_id := TLabel.Create('view.aliquotas.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.aliquotas.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.aliquotas.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.aliquotas.form.eddata_base_id');
  lbvalor := TLabel.Create('view.aliquotas.form.lbvalor');
  edvalor := TDBEdit.Create('view.aliquotas.form.edvalor');
  lblegenda := TLabel.Create('view.aliquotas.form.lblegenda');
  edlegenda := TDBEdit.Create('view.aliquotas.form.edlegenda');
  lbaliquota_compra := TLabel.Create('view.aliquotas.form.lbaliquota_compra');
  edaliquota_compra := TDBEdit.Create('view.aliquotas.form.edaliquota_compra');
  lbcodigo_interno := TLabel.Create('view.aliquotas.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.aliquotas.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.aliquotas.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.aliquotas.form.edexcluido');
  lbinclusao := TLabel.Create('view.aliquotas.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.aliquotas.form.edinclusao');
  lbalteracao := TLabel.Create('view.aliquotas.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.aliquotas.form.edalteracao');
  lbexclusao := TLabel.Create('view.aliquotas.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.aliquotas.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  AliquotasDataset := TXDataWebDataSet.Create(Self);
  AliquotasDatasetid := TIntegerField.Create(Self);
  AliquotasDatasetaliado_id := TIntegerField.Create(Self);
  AliquotasDatasetdata_base_id := TIntegerField.Create(Self);
  AliquotasDatasetvalor := TFloatField.Create(Self);
  AliquotasDatasetlegenda := TStringField.Create(Self);
  AliquotasDatasetaliquota_compra := TBooleanField.Create(Self);
  AliquotasDatasetcodigo_interno := TIntegerField.Create(Self);
  AliquotasDatasetexcluido := TBooleanField.Create(Self);
  AliquotasDatasetinclusao := TDateTimeField.Create(Self);
  AliquotasDatasetalteracao := TDateTimeField.Create(Self);
  AliquotasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientAliquotasGet := TXDataWebClient.Create(Self);
  XDataClientAliquotasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbvalor.BeforeLoadDFMValues;
  edvalor.BeforeLoadDFMValues;
  lblegenda.BeforeLoadDFMValues;
  edlegenda.BeforeLoadDFMValues;
  lbaliquota_compra.BeforeLoadDFMValues;
  edaliquota_compra.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  AliquotasDataset.BeforeLoadDFMValues;
  AliquotasDatasetid.BeforeLoadDFMValues;
  AliquotasDatasetaliado_id.BeforeLoadDFMValues;
  AliquotasDatasetdata_base_id.BeforeLoadDFMValues;
  AliquotasDatasetvalor.BeforeLoadDFMValues;
  AliquotasDatasetlegenda.BeforeLoadDFMValues;
  AliquotasDatasetaliquota_compra.BeforeLoadDFMValues;
  AliquotasDatasetcodigo_interno.BeforeLoadDFMValues;
  AliquotasDatasetexcluido.BeforeLoadDFMValues;
  AliquotasDatasetinclusao.BeforeLoadDFMValues;
  AliquotasDatasetalteracao.BeforeLoadDFMValues;
  AliquotasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientAliquotasGet.BeforeLoadDFMValues;
  XDataClientAliquotasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewAliquotasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbvalor.SetParentComponent(Self);
    lbvalor.Name := 'lbvalor';
    lbvalor.Left := 24;
    lbvalor.Top := 273;
    lbvalor.Width := 14;
    lbvalor.Height := 13;
    lbvalor.Caption := 'valor:';
    lbvalor.Transparent := True;
    edvalor.SetParentComponent(Self);
    edvalor.Name := 'edvalor';
    edvalor.Left := 221;
    edvalor.Top := 270;
    edvalor.Width := 200;
    edvalor.Height := 21;
    edvalor.Enabled := True;
    edvalor.TabOrder := 9;
    edvalor.Text := 'edvalor';
    edvalor.DataField := 'valor';
    edvalor.DataSource := DataSource;
    lblegenda.SetParentComponent(Self);
    lblegenda.Name := 'lblegenda';
    lblegenda.Left := 24;
    lblegenda.Top := 300;
    lblegenda.Width := 14;
    lblegenda.Height := 13;
    lblegenda.Caption := 'legenda:';
    lblegenda.Transparent := True;
    edlegenda.SetParentComponent(Self);
    edlegenda.Name := 'edlegenda';
    edlegenda.Left := 221;
    edlegenda.Top := 297;
    edlegenda.Width := 200;
    edlegenda.Height := 21;
    edlegenda.Enabled := True;
    edlegenda.TabOrder := 10;
    edlegenda.Text := 'edlegenda';
    edlegenda.DataField := 'legenda';
    edlegenda.DataSource := DataSource;
    lbaliquota_compra.SetParentComponent(Self);
    lbaliquota_compra.Name := 'lbaliquota_compra';
    lbaliquota_compra.Left := 24;
    lbaliquota_compra.Top := 327;
    lbaliquota_compra.Width := 14;
    lbaliquota_compra.Height := 13;
    lbaliquota_compra.Caption := 'aliquota_compra:';
    lbaliquota_compra.Transparent := True;
    edaliquota_compra.SetParentComponent(Self);
    edaliquota_compra.Name := 'edaliquota_compra';
    edaliquota_compra.Left := 221;
    edaliquota_compra.Top := 324;
    edaliquota_compra.Width := 200;
    edaliquota_compra.Height := 21;
    edaliquota_compra.Enabled := True;
    edaliquota_compra.TabOrder := 11;
    edaliquota_compra.Text := 'edaliquota_compra';
    edaliquota_compra.DataField := 'aliquota_compra';
    edaliquota_compra.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := AliquotasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    AliquotasDataset.SetParentComponent(Self);
    AliquotasDataset.Name := 'AliquotasDataset';
    AliquotasDataset.AfterApplyUpdates := AliquotasDatasetAfterApplyUpdates;
    AliquotasDataset.EntitySetName := 'Aliquotas';
    AliquotasDataset.Connection := DMConnection.ApiConnection;
    AliquotasDataset.Left := 176;
    AliquotasDataset.Top := 8;
    AliquotasDatasetid.SetParentComponent(AliquotasDataset);
    AliquotasDatasetid.Name := 'AliquotasDatasetid';
    AliquotasDatasetid.FieldName := 'id';
    AliquotasDatasetid.Required := True;
    AliquotasDatasetaliado_id.SetParentComponent(AliquotasDataset);
    AliquotasDatasetaliado_id.Name := 'AliquotasDatasetaliado_id';
    AliquotasDatasetaliado_id.FieldName := 'aliado_id';
    AliquotasDatasetaliado_id.Required := True;
    AliquotasDatasetdata_base_id.SetParentComponent(AliquotasDataset);
    AliquotasDatasetdata_base_id.Name := 'AliquotasDatasetdata_base_id';
    AliquotasDatasetdata_base_id.FieldName := 'data_base_id';
    AliquotasDatasetdata_base_id.Required := True;
    AliquotasDatasetvalor.SetParentComponent(AliquotasDataset);
    AliquotasDatasetvalor.Name := 'AliquotasDatasetvalor';
    AliquotasDatasetvalor.FieldName := 'valor';
    AliquotasDatasetvalor.Required := True;
    AliquotasDatasetlegenda.SetParentComponent(AliquotasDataset);
    AliquotasDatasetlegenda.Name := 'AliquotasDatasetlegenda';
    AliquotasDatasetlegenda.FieldName := 'legenda';
    AliquotasDatasetlegenda.Required := True;
    AliquotasDatasetlegenda.Size := 255;
    AliquotasDatasetaliquota_compra.SetParentComponent(AliquotasDataset);
    AliquotasDatasetaliquota_compra.Name := 'AliquotasDatasetaliquota_compra';
    AliquotasDatasetaliquota_compra.FieldName := 'aliquota_compra';
    AliquotasDatasetaliquota_compra.Required := True;
    AliquotasDatasetcodigo_interno.SetParentComponent(AliquotasDataset);
    AliquotasDatasetcodigo_interno.Name := 'AliquotasDatasetcodigo_interno';
    AliquotasDatasetcodigo_interno.FieldName := 'codigo_interno';
    AliquotasDatasetcodigo_interno.Required := True;
    AliquotasDatasetexcluido.SetParentComponent(AliquotasDataset);
    AliquotasDatasetexcluido.Name := 'AliquotasDatasetexcluido';
    AliquotasDatasetexcluido.FieldName := 'excluido';
    AliquotasDatasetexcluido.Required := False;
    AliquotasDatasetinclusao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetinclusao.Name := 'AliquotasDatasetinclusao';
    AliquotasDatasetinclusao.FieldName := 'inclusao';
    AliquotasDatasetinclusao.Required := False;
    AliquotasDatasetalteracao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetalteracao.Name := 'AliquotasDatasetalteracao';
    AliquotasDatasetalteracao.FieldName := 'alteracao';
    AliquotasDatasetalteracao.Required := False;
    AliquotasDatasetexclusao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetexclusao.Name := 'AliquotasDatasetexclusao';
    AliquotasDatasetexclusao.FieldName := 'exclusao';
    AliquotasDatasetexclusao.Required := False;
    XDataClientAliquotasGet.SetParentComponent(Self);
    XDataClientAliquotasGet.Name := 'XDataClientAliquotasGet';
    XDataClientAliquotasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAliquotasGet, Self, 'OnLoad', 'XDataClientAliquotasGetLoad');
    XDataClientAliquotasGet.Left := 64;
    XDataClientAliquotasGet.Top := 8;
    XDataClientAliquotasDelete.SetParentComponent(Self);
    XDataClientAliquotasDelete.Name := 'XDataClientAliquotasDelete';
    XDataClientAliquotasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAliquotasDelete, Self, 'OnLoad', 'XDataClientAliquotasDeleteLoad');
    SetEvent(XDataClientAliquotasDelete, Self, 'OnError', 'XDataClientAliquotasDeleteError');
    XDataClientAliquotasDelete.Left := 64;
    XDataClientAliquotasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbvalor.AfterLoadDFMValues;
    edvalor.AfterLoadDFMValues;
    lblegenda.AfterLoadDFMValues;
    edlegenda.AfterLoadDFMValues;
    lbaliquota_compra.AfterLoadDFMValues;
    edaliquota_compra.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    AliquotasDataset.AfterLoadDFMValues;
    AliquotasDatasetid.AfterLoadDFMValues;
    AliquotasDatasetaliado_id.AfterLoadDFMValues;
    AliquotasDatasetdata_base_id.AfterLoadDFMValues;
    AliquotasDatasetvalor.AfterLoadDFMValues;
    AliquotasDatasetlegenda.AfterLoadDFMValues;
    AliquotasDatasetaliquota_compra.AfterLoadDFMValues;
    AliquotasDatasetcodigo_interno.AfterLoadDFMValues;
    AliquotasDatasetexcluido.AfterLoadDFMValues;
    AliquotasDatasetinclusao.AfterLoadDFMValues;
    AliquotasDatasetalteracao.AfterLoadDFMValues;
    AliquotasDatasetexclusao.AfterLoadDFMValues;
    XDataClientAliquotasGet.AfterLoadDFMValues;
    XDataClientAliquotasDelete.AfterLoadDFMValues;
  end;
end;

end.
